import React, {useState, useEffect} from 'react'
import useCalendar from '@/modern/hooks/useCalendar'
import useSellerInfo from '@/modern/actions/useSellerInfo'

import {Calendar, InfoYear, SliderDays, ArrowLeft, ArrowRight, Carousel, Slide, DayOfWeek, DayOfMonth, CarouselContainer} from './style'

export default ({ setContinueIsActive, dayActive, setDayActive, allDays, setHourActive, setContinueHourIsActive }) => {
    const {sellerIsWorkingOnDay, getRoundedNowDate, getArrayOfDates, isAvaiable, sellerIsWorkingNow} = useCalendar()
    const {setSellerInfo} = useSellerInfo('schedule')
    const {sellerInfo} = useSellerInfo('weekSchedule')
    const [slideLength, setSlideLength] = useState(-21)
    const [pressedLeft, setPressedLeft] = useState(false)
    const [animate, setAnimate] = useState(false)
    const [animateBorder, setAnimateBorder] = useState(false)

    useEffect(() => {
        setContinueIsActive(sellerIsWorkingOnDay(allDays[dayActive].dayOfWeekNumber, allDays[dayActive].isHoliday))
    }, [])

    useEffect(() => {
        setSellerInfo(sellerIsWorkingNow(allDays[0].isHoliday) ? 'open' : 'closed')
    }, [allDays, sellerInfo])

    const handleRight = () => {
        if(dayActive < allDays.length -1) {
            setAnimate(true)
            setAnimateBorder(true)
            setPressedLeft(false)
            setDayActive(dayActive + 1)
            setSlideLength(slideLength - 21)
            setContinueIsActive(sellerIsWorkingOnDay(allDays[dayActive + 1].dayOfWeekNumber, allDays[dayActive + 1].isHoliday))

            const arrayOfDates = getArrayOfDates(allDays[dayActive + 1].dayOfWeekNumber)
            setHourActive(arrayOfDates[0])
            setContinueHourIsActive(true)
        }
    }

    const handleLeft = () => {
        if(dayActive > 0) {
            setAnimate(true)
            setAnimateBorder(true)
            setPressedLeft(true)
            setDayActive(dayActive - 1)
            setSlideLength(slideLength + 21)
            setContinueIsActive(sellerIsWorkingOnDay(allDays[dayActive - 1].dayOfWeekNumber, allDays[dayActive - 1].isHoliday))
        }

        if(dayActive === 1) {
            setHourActive(getRoundedNowDate())
            setContinueHourIsActive(isAvaiable(getRoundedNowDate()))
        }
        else {
            const arrayOfDates = getArrayOfDates(allDays[dayActive - 1].dayOfWeekNumber,  allDays[dayActive - 1].isHoliday)
            setHourActive(arrayOfDates[0])

            setContinueHourIsActive(true)
        }
    }

    const handleClick = day => {
        setAnimate(true)
        const index = allDays.findIndex(d => d.day === day.day && d.monthNumber === day.monthNumber)
        const difference = Math.abs(index - dayActive)

        if(difference === 2)
            setAnimateBorder(false)
         else
            setAnimateBorder(true)

        const goingToRight = index > dayActive

        setPressedLeft(!goingToRight)
        setDayActive(index)
        setSlideLength(-21 * index - 21)

        setContinueIsActive(sellerIsWorkingOnDay(allDays[index].dayOfWeekNumber, allDays[index].isHoliday))

        if(index === 0) {
            setHourActive(getRoundedNowDate())
            setContinueHourIsActive(isAvaiable(getRoundedNowDate()))
        }
        else {
            const arrayOfDates = getArrayOfDates(allDays[index].dayOfWeekNumber,  allDays[index].isHoliday)
            setHourActive(arrayOfDates[0])
            setContinueHourIsActive(true)
        }
    }

    const dataFormTest = 'calendar_videochamada'
    const dataTestLabel = 'sliderdays_videochamada'

    function handleDataQA(day) {
      return sellerIsWorkingOnDay(day.dayOfWeekNumber, day.isHoliday)
        ? 'enabled'
        : 'disabled'
    }

    return (
        <Calendar data-test-component={dataFormTest}>
            <InfoYear>{allDays[dayActive].month}, {allDays[dayActive].year}</InfoYear>
            <CarouselContainer>
                <ArrowLeft data-qa="btn_calendar_day_prev" disabled={!allDays[dayActive - 1]} onClick={handleLeft}> {'<'} </ArrowLeft>
                <SliderDays>
                    <Slide  data-test-component={dataTestLabel}>
                        <DayOfWeek></DayOfWeek>
                        <DayOfMonth></DayOfMonth>
                    </Slide>
                    <Slide  data-test-component={dataTestLabel}>
                        <DayOfWeek></DayOfWeek>
                        <DayOfMonth></DayOfMonth>
                    </Slide>
                    <Slide  data-test-component={dataTestLabel}>
                        <DayOfWeek></DayOfWeek>
                        <DayOfMonth></DayOfMonth>
                    </Slide>
                    <Carousel slideLeft={slideLength} slideRight={slideLength} pressedLeft={pressedLeft === true} animate={animate}>
                        {allDays.map(day => (
                            <Slide data-test-component={dataTestLabel}
                            data-qa={`day_${handleDataQA(day)}`}
                            isGray={!sellerIsWorkingOnDay(day.dayOfWeekNumber, day.isHoliday)}
                            isSelected={day.day === allDays[dayActive].day && day.month === allDays[dayActive].month}
                            onClick={() => handleClick(day)}
                            animateBorder={animateBorder}
                            >
                                <DayOfWeek>{day.dayOfWeek}</DayOfWeek>
                                <DayOfMonth>{day.day}</DayOfMonth>
                            </Slide>
                        ))}
                    </Carousel>
                </SliderDays>
                <ArrowRight data-qa="btn_calendar_day_next" onClick={handleRight} disabled={!allDays[dayActive + 1]}> {'>'} </ArrowRight>
            </CarouselContainer>
        </Calendar>
    )
}
